import { render, staticRenderFns } from "./systemcs.vue?vue&type=template&id=0580be5c&scoped=true&"
import script from "./systemcs.vue?vue&type=script&lang=js&"
export * from "./systemcs.vue?vue&type=script&lang=js&"
import style0 from "./systemcs.vue?vue&type=style&index=0&id=0580be5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0580be5c",
  null
  
)

export default component.exports